"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMediaDimensions = void 0;
exports.getFelaRenderer = getFelaRenderer;
const fela_1 = require("fela");
const fela_monolithic_1 = __importDefault(require("fela-monolithic"));
const fela_plugin_extend_1 = __importDefault(require("fela-plugin-extend"));
const fela_plugin_fallback_value_1 = __importDefault(require("fela-plugin-fallback-value"));
const fela_plugin_important_1 = __importDefault(require("fela-plugin-important"));
const fela_plugin_named_keys_1 = __importDefault(require("fela-plugin-named-keys"));
const fela_plugin_prefixer_1 = __importDefault(require("fela-plugin-prefixer"));
const fela_plugin_unit_1 = __importDefault(require("fela-plugin-unit"));
// import validatorPlugin from "fela-plugin-validator";
var EMediaDimensions;
(function (EMediaDimensions) {
    EMediaDimensions[EMediaDimensions["DesktopStart"] = 1024] = "DesktopStart";
    EMediaDimensions[EMediaDimensions["TabletStart"] = 585] = "TabletStart";
    EMediaDimensions[EMediaDimensions["MobileSmallEnd"] = 290] = "MobileSmallEnd";
})(EMediaDimensions || (exports.EMediaDimensions = EMediaDimensions = {}));
const mediaQueries = {
    desktopOnly: `@media (min-width: ${EMediaDimensions.DesktopStart}px)`,
    tabletOnly: `@media (min-width: ${EMediaDimensions.TabletStart}px) and (max-width: ${EMediaDimensions.DesktopStart - 1}px)`,
    tabletUpwards: `@media (min-width: ${EMediaDimensions.TabletStart}px)`,
    tabletDownwards: `@media (max-width: ${EMediaDimensions.DesktopStart - 1}px)`,
    mobileOnly: `@media (max-width: ${EMediaDimensions.TabletStart - 1}px)`,
    smallMobileOnly: `@media (max-width: ${EMediaDimensions.MobileSmallEnd}px)`,
};
console.log(fela_plugin_named_keys_1.default);
const namedKeysPlugin = (0, fela_plugin_named_keys_1.default)(mediaQueries);
let unitPlugin = (0, fela_plugin_unit_1.default)("em");
function getFelaRenderer({ usePlugins: { important = false } = {}, extraStyles, defaultUnit, } = {}) {
    let renderer;
    if (defaultUnit) {
        unitPlugin = (0, fela_plugin_unit_1.default)(defaultUnit);
    }
    if (process.env.NODE_ENV !== "production") {
        renderer = (0, fela_1.createRenderer)({
            plugins: [
                (0, fela_plugin_extend_1.default)(),
                ...(important ? [(0, fela_plugin_important_1.default)()] : []),
                (0, fela_plugin_prefixer_1.default)(),
                (0, fela_plugin_fallback_value_1.default)(),
                unitPlugin,
                namedKeysPlugin,
                // logger(),
                // validatorPlugin(),
            ],
            enhancers: [(0, fela_monolithic_1.default)()],
            // enhancers: [perf()],
        });
    }
    else {
        renderer = (0, fela_1.createRenderer)({
            plugins: [
                (0, fela_plugin_extend_1.default)(),
                ...(important ? [(0, fela_plugin_important_1.default)()] : []),
                // importantPlugin(),
                (0, fela_plugin_prefixer_1.default)(),
                (0, fela_plugin_fallback_value_1.default)(),
                unitPlugin,
                namedKeysPlugin,
                // logger(),
            ],
        });
    }
    if (extraStyles) {
        renderer.renderStatic(extraStyles);
    }
    return renderer;
}
